import { colors } from '@ardoq/design-tokens';
import {
  HtmlCanvasVisual,
  type IRenderContext,
  type Rect,
  type Font,
} from '@ardoq/yfiles';
import { MultiLabelStyle, DEFAULT_MULTI_LABEL_STYLE } from '@ardoq/graph';
import { fillAndStrokeWithShadowLayers, shadowLayers } from 'tabview/utils';
import {
  MODERNIZED_BLOCK_DIAGRAM_OTHER_LABEL_VERTICAL_PADDING as VERTICAL_PADDING,
  MODERNIZED_BLOCK_DIAGRAM_OTHER_LABEL_PADDING as INTERIOR_PADDING,
} from 'yfilesExtensions/styles/modernized/consts';

class CanvasOpenGroupOtherLabelVisual extends HtmlCanvasVisual {
  constructor(
    private container: Rect,
    private rects: Rect[],
    private lines: string[][],
    private font: Font,
    private lineHeight: number,
    private opacity: number,
    private styles: MultiLabelStyle[]
  ) {
    super();
  }

  render(_: IRenderContext, ctx: CanvasRenderingContext2D): void {
    const a = ctx.globalAlpha;
    ctx.globalAlpha = this.opacity;
    ctx.fillStyle = colors.white950;
    ctx.font = `${this.font.fontWeight} ${this.font.fontSize}px ${this.font.fontFamily}`;
    ctx.textAlign = 'start';
    ctx.textBaseline = 'middle';
    ctx.lineWidth = 1;

    const x = this.container.x;
    const labelX = x + INTERIOR_PADDING;

    for (let i = 0; i < this.rects.length; i++) {
      const style = this.styles[i] ?? DEFAULT_MULTI_LABEL_STYLE;

      const r = this.rects[i];
      const y = this.container.y + r.y;
      const w = r.width;
      const h = r.height;

      const buildPath = () => {
        ctx.beginPath();
        ctx.roundRect(x, y, w, h, 4);
      };

      fillAndStrokeWithShadowLayers(
        ctx,
        shadowLayers,
        style.groupFillStyle,
        style.strokeStyle,
        buildPath
      );

      const ls = this.lines[i] ?? [];
      const firstLineY = y + VERTICAL_PADDING + this.lineHeight / 2;
      ctx.fillStyle = colors.black950;
      for (let j = 0; j < ls.length; j++) {
        ctx.fillText(ls[j], labelX, firstLineY + j * this.lineHeight);
      }
    }
    ctx.globalAlpha = a;
  }
}
export { CanvasOpenGroupOtherLabelVisual };
